<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.contract_details") }}</h4>
    </div>
    <div class="col-12 text-end mb-3">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badge ==== -->
      <div class="badges_wrapper justify-content-end mb-3">
        <v-chip
          :color="data.status === 'replied' ? 'green' : 'orange'"
          text-color="white"
        >
          {{ data.status === "new" ? $t("STATUS.new") : $t("STATUS.replied") }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badge ==== -->

      <!-- ==== Start:: Contract Main Data ==== -->
      <form>
        <div class="row">
          <!-- Start:: Created At -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model.trim="data.created_at"
            disabled
            class="disabled_input"
          />
          <!-- End:: Created At -->

          <!-- Start:: Contract Type -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.contract_type_filter')"
            v-model.trim="data.contract_type"
            disabled
            class="disabled_input"
          />
          <!-- End:: Contract Type -->

          <!-- Start:: Estate Type -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.estate_type')"
            v-model.trim="data.estate_type"
            disabled
            class="disabled_input"
          />
          <!-- End:: Estate Type -->

          <!-- Start:: Landlord Type -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.landlord_type')"
            v-model.trim="data.landlord_type"
            disabled
            class="disabled_input"
          />
          <!-- End:: Landlord Type -->

          <!-- Start:: Instrument Image -->
          <div class="col-md-6 mb-3" v-if="data.instrument_image">
            <label class="form-label">{{
              $t("PLACEHOLDERS.instrument_image")
            }}</label>
            <div class="preview-container text-center">
              <img
                :src="data.instrument_image"
                :alt="$t('PLACEHOLDERS.instrument_image')"
              />
            </div>
          </div>
          <!-- End:: Instrument Image -->

          <!-- Start:: Agency Image (Only if landlord is broker) -->
          <div
            class="col-md-6 mb-3"
            v-if="data.landlord_type_value === 'broker' && data.agency_image"
          >
            <label class="form-label">{{
              $t("PLACEHOLDERS.agency_image")
            }}</label>
            <div class="preview-container text-center">
              <img
                :src="data.agency_image"
                :alt="$t('PLACEHOLDERS.agency_image')"
              />
            </div>
          </div>
          <!-- End:: Agency Image -->

          <!-- Start:: Landlord Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.landlord_name')"
            v-model.trim="data.landlord_name"
            disabled
            class="disabled_input"
          />
          <!-- End:: Landlord Name -->

          <!-- Start:: National ID -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.national_id')"
            v-model.trim="data.national_id"
            disabled
            class="disabled_input"
          />
          <!-- End:: National ID -->

          <!-- Start:: ID Image -->
          <div class="col-md-6 mb-3" v-if="data.id_image">
            <label class="form-label">{{ $t("PLACEHOLDERS.id_image") }}</label>
            <div class="preview-container text-center">
              <img :src="data.id_image" :alt="$t('PLACEHOLDERS.id_image')" />
            </div>
          </div>
          <!-- End:: ID Image -->

          <!-- Start:: Mobile -->
          <base-input
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.mobile')"
            v-model.trim="data.mobile"
            disabled
            class="disabled_input"
          />
          <!-- End:: Mobile -->

          <!-- Start:: Region -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.region')"
            v-model.trim="data.state"
            disabled
            class="disabled_input"
          />
          <!-- End:: Region -->

          <!-- Start:: City -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city"
            disabled
            class="disabled_input"
          />
          <!-- End:: City -->

          <!-- Start:: District -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.district')"
            v-model.trim="data.district"
            disabled
            class="disabled_input"
          />
          <!-- End:: District -->

          <!-- Start:: Address -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="data.address"
            disabled
            class="disabled_input"
          />
          <!-- End:: Address -->

          <!-- Start:: Map Location -->
          <div class="col-12 mb-3" v-if="data.lat && data.lng">
            <label class="form-label">{{
              $t("PLACEHOLDERS.location_on_map")
            }}</label>
            <div class="map-container">
              <iframe
                :src="`https://maps.google.com/maps?q=${data.lat},${data.lng}&z=15&output=embed`"
                width="100%"
                height="400"
                style="border: 0; border-radius: 10px"
                allowfullscreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
          <!-- End:: Map Location -->

          <!-- Start:: Area -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.area')"
            v-model.trim="data.area"
            disabled
            class="disabled_input"
          />
          <!-- End:: Area -->

          <!-- Start:: Estate Status -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.estate_status')"
            v-model.trim="data.estate_status"
            disabled
            class="disabled_input"
          />
          <!-- End:: Estate Status -->

          <!-- Start:: Contract Duration -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.contract_duration')"
            v-model.trim="data.contract_duration"
            disabled
            class="disabled_input"
          />
          <!-- End:: Contract Duration -->

          <!-- Start:: Contract Start Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.contract_start_date')"
            v-model.trim="data.contract_start_date"
            disabled
            class="disabled_input"
          />
          <!-- End:: Contract Start Date -->

          <!-- Start:: Contract End Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.contract_end_date')"
            v-model.trim="data.contract_end_date"
            disabled
            class="disabled_input"
          />
          <!-- End:: Contract End Date -->

          <!-- Start:: Amount -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.amount')"
            v-model.trim="data.amount"
            disabled
            class="disabled_input"
          />
          <!-- End:: Amount -->

          <!-- Start:: Payment Way -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.payment_way')"
            v-model.trim="data.payment_way"
            disabled
            class="disabled_input"
          />
          <!-- End:: Payment Way -->

          <!-- Start:: Prepaid Amount -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.prepaid_amount')"
            v-model.trim="data.prepaid_amount"
            disabled
            class="disabled_input"
          />
          <!-- End:: Prepaid Amount -->

          <!-- Start:: Additional Fields -->
          <template
            v-if="data.additional_fields && data.additional_fields.length > 0"
          >
            <div class="col-12 mb-3">
              <h5 class="mb-3">{{ $t("PLACEHOLDERS.additional_fields") }}</h5>
            </div>
            <div class="custom-form-wrapper">
              <div
                v-for="field in data.additional_fields"
                :key="field.id"
                class="custom-form-field"
              >
                <div v-if="field.type === 'text'">
                  <base-input
                    v-model="field.values"
                    type="text"
                    disabled
                    :placeholder="field.name"
                    :icon="field.icon"
                    class="disabled_input"
                  />
                </div>

                <div v-else-if="field.type === 'number'">
                  <base-input
                    v-model.number="field.values"
                    type="number"
                    disabled
                    :placeholder="field.name"
                    :icon="field.icon"
                    class="disabled_input"
                  />
                </div>

                <div v-else-if="field.type === 'textarea'">
                  <base-input
                    v-model="field.values"
                    type="textarea"
                    disabled
                    :placeholder="field.name"
                    :icon="field.icon"
                    class="disabled_input"
                  />
                </div>

                <div v-else-if="field.type === 'checkbox'" class="my-3">
                  <label class="field-label d-block mb-2">
                    <img v-if="field.icon" :src="field.icon" class="img" />
                    {{ field.name }}
                  </label>
                  <label
                    v-for="option in field.options"
                    :key="option.id"
                    class="custom-checkbox-wrapper"
                  >
                    <input
                      type="checkbox"
                      class="custom-checkbox-input"
                      :value="option"
                      v-model="field.values"
                      disabled
                    />
                    <span
                      class="custom-checkbox-box"
                      :class="{
                        bg: field.values.some((val) => val.id === option.id),
                      }"
                    ></span>
                    <span class="custom-checkbox-label">
                      {{ option.trans?.option_name?.ar || option.name }}
                    </span>
                  </label>
                </div>

                <div v-else-if="field.type === 'radio'">
                  <label class="field-label d-block mb-2">
                    <img v-if="field.icon" :src="field.icon" class="img" />
                    {{ field.name }}
                  </label>
                  <div
                    v-for="(option, i) in field?.options"
                    :key="i"
                    class="custom-radio-wrapper"
                  >
                    <input
                      type="radio"
                      disabled
                      class="custom-radio-input"
                      :id="`radio_${field.id}_${i}`"
                      :name="`radio_${field.id}`"
                      :value="option.id"
                      v-model="field.values.id"
                      :icon="field.icon"
                    />
                    <label
                      class="custom-radio-label"
                      :for="`radio_${field.id}_${i}`"
                    >
                      {{ option.name }}
                    </label>
                  </div>
                </div>

                <div v-else-if="field.type === 'select'">
                  <base-select-input
                    :placeholder="field.name"
                    :icon="field.icon"
                    disabled
                    :optionsList="
                      field.options?.map((option) => ({
                        name: option.name,
                        value: option?.name,
                        id: option.id,
                      }))
                    "
                    v-model="field.values"
                    class="disabled_input"
                  />
                </div>
              </div>
            </div>
          </template>
          <!-- End:: Additional Fields -->

          <!-- Start:: Electronic Contract PDF (Only if status is replied) -->
          <div
            class="col-12 mb-3"
            v-if="data.status === 'replied' && data.contract_pdf"
          >
            <label class="form-label">{{
              $t("PLACEHOLDERS.electronic_contract")
            }}</label>
            <div class="d-flex align-items-center gap-2">
              <v-btn
                color="primary"
                :href="data.contract_pdf"
                target="_blank"
                class="me-2"
              >
                <i class="fal fa-file-pdf me-2"></i>
                {{ $t("BUTTONS.downloadPdf") }}
              </v-btn>
            </div>
          </div>
          <!-- End:: Electronic Contract PDF -->
        </div>
      </form>
      <!-- ==== End:: Contract Main Data ==== -->
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowContract",

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Loading Data
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Data
      data: {
        created_at: null,
        status: null,
        contract_type: null,
        estate_type: null,
        landlord_type: null,
        landlord_type_value: null,
        landlord_name: null,
        national_id: null,
        mobile: null,
        state: null,
        city: null,
        district: null,
        address: null,
        area: null,
        estate_status: null,
        contract_duration: null,
        contract_start_date: null,
        contract_end_date: null,
        amount: null,
        payment_way: null,
        prepaid_amount: null,
        lat: null,
        lng: null,
        instrument_image: null,
        agency_image: null,
        id_image: null,
        contract_pdf: null,
        additional_fields: [],
      },
      // End:: Data
    };
  },

  methods: {
    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `rent-contracts/${this.$route.params.id}`,
        });

        const contract = res.data.data.rentContract;

        this.data.created_at = this.formatDate(contract.created_at);
        this.data.status = contract.status;
        this.data.contract_type = contract._contract_type;
        this.data.estate_type = contract.estate_type?.name || null;
        this.data.landlord_type = contract._landlord_type;
        this.data.landlord_type_value = contract.landlord_type;
        this.data.landlord_name = contract.landlord_name;
        this.data.national_id = contract.national_id;
        this.data.mobile = contract.mobile;
        this.data.state = contract.state?.name || null;
        this.data.city = contract.city?.name || null;
        this.data.district = contract.district?.name || null;
        this.data.address = contract.address;
        this.data.area = contract.area
          ? `${contract.area} ${this.$t("PLACEHOLDERS.square_meter")}`
          : null;
        this.data.estate_status = contract._estate_status;
        this.data.contract_duration = contract.contract_duration;
        this.data.contract_start_date = this.formatDate(
          contract.contract_start_date
        );
        this.data.contract_end_date = this.formatDate(
          contract.contract_end_date
        );
        this.data.amount = contract.amount
          ? `${contract.amount} ${this.$t("PLACEHOLDERS.currency")}`
          : null;
        this.data.payment_way = contract._payment_way;
        this.data.prepaid_amount = contract.prepaid_amount
          ? `${contract.prepaid_amount} ${this.$t("PLACEHOLDERS.currency")}`
          : null;
        this.data.lat = contract.lat;
        this.data.lng = contract.lng;
        this.data.instrument_image = contract.instrument_image;
        this.data.agency_image = contract.agency_image;
        this.data.id_image = contract.id_image;
        this.data.contract_pdf = contract.contract_pdf;
        this.data.additional_fields = contract.additional_fields || [];
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات"
        );
      }
    },
    // End:: Get Data To Show

    // Start:: Format Date
    formatDate(dateString) {
      if (!dateString) return null;

      try {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
      } catch (error) {
        return dateString;
      }
    },
    // End:: Format Date
  },

  created() {
    // Start:: Fire Methods
    this.getDataToShow();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.preview-container img {
  max-width: 100%;
  max-height: 250px;
  border: 1px solid #ccc;
  border-radius: 10px;
  object-fit: contain;
}

.map-container {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
}

.disabled_input {
  opacity: 1 !important;
}

.form-label {
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

.gap-2 {
  gap: 0.5rem;
}

.custom-form-wrapper {
  width: 100%;
  padding: 0 15px;
}

.custom-form-field {
  margin-bottom: 1.5rem;
}

.field-label {
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.field-label .img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.custom-checkbox-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: not-allowed;
}

.custom-checkbox-input {
  display: none;
}

.custom-checkbox-box {
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
  display: inline-block;
}

.custom-checkbox-box.bg {
  background-color: green !important;
  border-color: green;
}

.custom-checkbox-label {
  color: #333;
  font-size: 14px;
}

.custom-radio-wrapper {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.custom-radio-input {
  margin-right: 10px;
  cursor: not-allowed;
}

.custom-radio-label {
  color: #333;
  font-size: 14px;
  cursor: not-allowed;
}
</style>
